// Konfiguration der Betonrechner-Landingpages. Geteilt von React-Pages und
// scripts/prerender.js (lädt via vm-Shim, daher reines `export const`).
export const BETON_SEITEN = [
  {
    slug: "beton-berechnen",
    preset: "quader",
    title: "Beton berechnen: Menge, Säcke und Gewicht online ausrechnen",
    description:
      "Wie viel Beton brauche ich? Maße eingeben und Volumen in m³, Anzahl Trockenbeton-Säcke und Gewicht sofort berechnen.",
    h1: "Beton berechnen",
    intro:
      "Gib die Maße deines Bauteils ein und du bekommst sofort die benötigte Betonmenge in Kubikmeter, die Anzahl Trockenbeton-Säcke (25 und 40 kg) und das Gewicht. Für Fundamente, Säulen und Platten wähle oben das passende Bauteil.",
    faq: [
      { q: "Wie viel Beton brauche ich pro Kubikmeter in Säcken?", a: "Aus einem 40-kg-Sack Trockenbeton werden etwa 0,02 m³, aus einem 25-kg-Sack etwa 0,0125 m³. Für einen Kubikmeter brauchst du also rund 50 Säcke à 40 kg oder rund 80 Säcke à 25 kg." },
      { q: "Warum ein Zuschlag?", a: "Beim Verdichten und durch Verschnitt geht etwas Volumen verloren. 5 bis 10 % Zuschlag sorgen dafür, dass du nicht zu knapp bestellst." },
    ],
  },
  {
    slug: "betonfundament-berechnen",
    preset: "streifenfundament",
    title: "Betonfundament berechnen: Beton für das Fundament ausrechnen",
    description:
      "Beton fürs Fundament berechnen. Maße eingeben und Volumen, Säcke und Gewicht für Streifen- oder Punktfundament sehen.",
    h1: "Betonfundament berechnen",
    intro:
      "Für ein Fundament zählt das Volumen aus Länge, Breite und Tiefe. Gib die Maße ein und du siehst die nötige Betonmenge. Für einzelne Punkte wähle oben Punktfundament, für einen durchgehenden Streifen das Streifenfundament.",
    faq: [
      { q: "Wie berechne ich Beton für ein Streifenfundament?", a: "Gesamtlänge × Breite × Tiefe ergibt das Volumen in m³. Beispiel: 20 m × 0,30 m × 0,60 m = 3,6 m³. Mit 5 % Zuschlag rund 3,78 m³." },
      { q: "Gilt das als statische Berechnung?", a: "Nein. Der Rechner schätzt nur die Materialmenge. Die Bemessung von Fundamenten gehört in die Hand einer Fachperson." },
    ],
  },
  {
    slug: "streifenfundament-berechnen",
    preset: "streifenfundament",
    title: "Streifenfundament berechnen: Betonmenge für den Fundamentstreifen",
    description:
      "Streifenfundament-Beton berechnen. Gesamtlänge, Breite und Tiefe eingeben, Volumen und Säcke sofort sehen.",
    h1: "Streifenfundament berechnen",
    intro:
      "Beim Streifenfundament läuft der Beton als durchgehender Streifen unter den tragenden Wänden. Gib die gesamte Lauflänge, die Breite und die Tiefe ein, der Rechner liefert Volumen, Säcke und Gewicht.",
    faq: [
      { q: "Welche Tiefe braucht ein Streifenfundament?", a: "In frostfreier Gründung üblich sind etwa 80 cm Tiefe, die Breite richtet sich nach der Last. Maße im Zweifel mit einer Fachperson abstimmen, der Rechner liefert nur die Menge." },
    ],
  },
  {
    slug: "punktfundament-berechnen",
    preset: "punktfundament",
    title: "Punktfundament berechnen: Beton pro Punkt und gesamt",
    description:
      "Punktfundament-Beton berechnen. Anzahl und Maße der Punkte eingeben, Gesamtvolumen und Säcke sehen.",
    h1: "Punktfundament berechnen",
    intro:
      "Punktfundamente tragen einzelne Stützen, zum Beispiel für Carport oder Terrasse. Gib die Anzahl und die Maße eines Punktes ein, der Rechner rechnet auf die Gesamtmenge hoch.",
    faq: [
      { q: "Wie viel Beton braucht ein Punktfundament?", a: "Pro Punkt: Länge × Breite × Tiefe. Beispiel: 0,40 × 0,40 × 0,80 m = 0,128 m³, bei 4 Punkten also rund 0,51 m³ plus Zuschlag." },
    ],
  },
  {
    slug: "bodenplatte-berechnen",
    preset: "bodenplatte",
    title: "Bodenplatte berechnen: Beton für die Bodenplatte ausrechnen",
    description:
      "Beton für die Bodenplatte berechnen. Länge, Breite und Dicke eingeben, Volumen, Säcke und Gewicht sehen.",
    h1: "Bodenplatte berechnen",
    intro:
      "Für eine Bodenplatte zählt Länge mal Breite mal Dicke. Gib die Maße ein, der Rechner zeigt dir das Betonvolumen, die Anzahl Säcke und das Gewicht.",
    faq: [
      { q: "Wie dick muss eine Bodenplatte sein?", a: "Für Gartenhäuser oft 10 bis 15 cm, bei höherer Last mehr. Der Rechner nimmt deine Dicke und liefert die Menge, die Bemessung bleibt Sache der Fachplanung." },
    ],
  },
  {
    slug: "estrichrechner",
    preset: "bodenplatte",
    title: "Estrichrechner: Estrichmenge nach Fläche und Dicke berechnen",
    description:
      "Estrich berechnen. Fläche (Länge × Breite) und Dicke eingeben, benötigte Menge in m³ und Säcken sehen.",
    h1: "Estrich berechnen",
    intro:
      "Estrich rechnet sich wie eine Platte: Länge mal Breite mal Dicke. Gib die Raummaße und die gewünschte Estrichdicke ein, der Rechner liefert Volumen, Säcke und Gewicht.",
    faq: [
      { q: "Wie viel Estrich pro Quadratmeter?", a: "Pro m² und cm Dicke sind es 0,01 m³. Bei 5 cm Dicke also 0,05 m³ pro m². Der Rechner macht das für deine Gesamtfläche automatisch." },
    ],
  },
  {
    slug: "beton-gewicht-berechnen",
    preset: "quader",
    title: "Beton Gewicht berechnen: Gewicht aus dem Volumen",
    description:
      "Betongewicht berechnen. Maße eingeben und das Gewicht in kg aus dem Volumen und der Dichte sehen.",
    h1: "Beton Gewicht berechnen",
    intro:
      "Normalbeton wiegt rund 2.400 kg pro Kubikmeter. Gib die Maße deines Bauteils ein, der Rechner zeigt Volumen und das daraus folgende Gewicht.",
    faq: [
      { q: "Wie viel wiegt ein Kubikmeter Beton?", a: "Normalbeton wiegt etwa 2.400 kg pro m³. Ein Kubikmeter entspricht also gut 2,4 Tonnen." },
    ],
  },
];

export const BETON_HUB = {
  slug: "betonrechner",
  title: "Betonrechner: Betonmenge, Säcke und Gewicht online berechnen",
  description:
    "Kostenloser Betonrechner für Bodenplatte, Fundament, Säule und freie Bauteile. Maße eingeben, Volumen in m³, Säcke und Gewicht sofort sehen.",
  h1: "Betonrechner",
  faq: [
    { q: "Wie viel Beton brauche ich?", a: "Das hängt vom Bauteil ab. Bei Platten und Streifen ist es Länge × Breite × Dicke, bei runden Säulen π × Radius² × Höhe. Wähle oben das Bauteil und gib die Maße ein, der Rechner liefert Volumen, Säcke und Gewicht." },
    { q: "Wie viele Säcke Beton pro Kubikmeter?", a: "Rund 50 Säcke à 40 kg oder rund 80 Säcke à 25 kg ergeben einen Kubikmeter Trockenbeton." },
    { q: "Wie viel wiegt der Beton?", a: "Normalbeton wiegt etwa 2.400 kg pro m³. Der Rechner zeigt das Gewicht passend zu deiner Menge." },
  ],
};
